import useLogFilters from 'hooks/useLogFilters'
import {
  FilterDateInput,
  FilterTextInput,
} from 'components/common/logFilterInputs'

export const FILTER_FIELD_EXPORT_LOG = 'exportLogFilters'

const ExportLogFilterForm = () => {
  const { filters, setField } = useLogFilters(FILTER_FIELD_EXPORT_LOG)

  return (
    <div className="mb-6 flex flex-wrap items-end gap-4 rounded-xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
      <FilterTextInput
        label="User"
        value={filters.user || ''}
        onApply={(value) => setField('user', value)}
      />
      <FilterTextInput
        label="Employee ID"
        value={filters.empId || ''}
        onApply={(value) => setField('empId', value)}
      />
      <FilterTextInput
        label="Module"
        value={filters.module || ''}
        onApply={(value) => setField('module', value)}
      />
      <FilterTextInput
        label="Status"
        value={filters.status || ''}
        onApply={(value) => setField('status', value)}
      />
      <FilterDateInput
        label="Start Date"
        value={filters.startDate || ''}
        onChange={(value) => setField('startDate', value)}
      />
      <FilterDateInput
        label="End Date"
        value={filters.endDate || ''}
        onChange={(value) => setField('endDate', value)}
      />
    </div>
  )
}

export default ExportLogFilterForm
